import { css } from "emotion";
import React from "react";
import { max } from "../../utils/CssUtils";
import CMSComponent from "../CMSComponent";
import { H3 } from "../global/TextComponents";
import ContentBlock from "./ContentBlock";
import Slider from "./Slider";
import Image from "../global/Image";

//au
const barker = require("../../assets/TrustedBy/au/logo-barker-college.svg");
const cancer = require("../../assets/TrustedBy/au/logo-cancer-council.svg");
const ffa = require("../../assets/TrustedBy/au/logo-ffa.svg");
const graounds = require("../../assets/TrustedBy/au/logo-graounds.svg");
const hearts = require("../../assets/TrustedBy/au/logo-hearts-minds.svg");
const folk = require("../../assets/TrustedBy/au/logo-illawara-folk-festival.svg");
const inner = require("../../assets/TrustedBy/au/logo-inner-warnika.svg");
const parlament = require("../../assets/TrustedBy/au/logo-parlament-house.svg");
const rotoract = require("../../assets/TrustedBy/au/logo-rotoract.svg");
const uts = require("../../assets/TrustedBy/au/logo-uts.svg");
const igs = require("../../assets/TrustedBy/au/igs.png");

//nz
const attitude = require("../../assets/TrustedBy/nz/logo-attitude.png");
const ballantynes = require("../../assets/TrustedBy/nz/logo-ballantynes.svg");
const creative = require("../../assets/TrustedBy/nz/logo-creative-hq.svg");
const westpac = require("../../assets/TrustedBy/nz/logo-westpac.svg");
const verb = require("../../assets/TrustedBy/nz/logo-verb.png");
const lawFest = require("../../assets/TrustedBy/nz/logo-lawFest.png");
const callaghan = require("../../assets/TrustedBy/nz/logo-callaghanInnovation.png");
const sustainableCoast = require("../../assets/TrustedBy/nz/logo-sustainableCoastlines.png");
const unfiltered = require("../../assets/TrustedBy/nz/logo-unfiltered.png");
const restaurantAssoc = require("../../assets/TrustedBy/nz/logo-restaurantAssoc.png");
const otago = require("../../assets/TrustedBy/nz/logo-otagoUni.png");

//universal
const un = require("../../assets/TrustedBy/au/logo-un-women.svg");
const westfield = require("../../assets/TrustedBy/au/logo-westfield.svg");
const singularity = require("../../assets/TrustedBy/au/logo-singularity-university.svg");
const school = require("../../assets/TrustedBy/au/logo-school-oflife.svg");

const logos = {
  au: [
    {
      img: un,
      alt: "UN Women",
      row: 1
    },
    {
      img: uts,
      alt: "University of Technology Sydney",
      row: 1
    },
    {
      img: ffa,
      alt: "Football federation australia",
      row: 1
    },
    {
      img: parlament,
      alt: "australian parlament house",
      row: 1
    },
    {
      img: rotoract,
      alt: "Rotaract",
      row: 1
    },
    {
      img: graounds,
      alt: "The Grounds of Alexandria",
      row: 2
    },
    {
      img: cancer,
      alt: "Cancer Council",
      row: 2
    },
    {
      img: westfield,
      alt: "Westfields",
      row: 2
    },
    {
      img: barker,
      alt: "Barker College",
      row: 2
    },
    {
      img: singularity,
      alt: "Singularity University",
      row: 3
    },
    {
      img: folk,
      alt: "Illawara Folk Festival",
      row: 3
    },
    {
      img: school,
      alt: "School of Life",
      row: 3
    },
    {
      img: hearts,
      alt: "Hearts and Minds Investments",
      row: 3
    },
    {
      img: inner,
      alt: "Inner Varnika",
      row: 3
    }
  ],
  nz: [
    {
      img: un,
      alt: "UN Women",
      row: 1
    },
    {
      img: verb,
      alt: "Verb",
      row: 1
    },
    {
      img: attitude,
      alt: "Attitude Trust",
      row: 1
    },
    {
      img: westpac,
      alt: "Westpac",
      row: 1
    },
    {
      img: creative,
      alt: "Creative HQ",
      row: 1
    },
    {
      img: lawFest,
      alt: "Law Fest",
      row: 2
    },
    {
      img: callaghan,
      alt: "Callaghan Innovation",
      row: 2
    },
    {
      img: sustainableCoast,
      alt: "Sustainable Coastlines",
      row: 2
    },
    {
      img: unfiltered,
      alt: "Unfiltered",
      row: 2
    },
    {
      img: singularity,
      alt: "Singularity University",
      row: 3
    },
    {
      img: restaurantAssoc,
      alt: "Restaurant Association",
      row: 3
    },
    {
      img: school,
      alt: "The School Of Life",
      row: 3
    },
    {
      img: ballantynes,
      alt: "Ballantynes",
      row: 3
    },
    {
      img: otago,
      alt: "Otaga University",
      row: 3
    }
  ]
};

const wrapper = css({
  display: "block",
  width: 760,
  margin: "0 auto",
  div: {
    display: "flex",
    justifyContent: "center"
  },
  img: {
    width: 130,
    height: 56,
    margin: "6px 12px",
    objectFit: "scale-down !important"
  },
  [max(800)]: {
    margin: 0
  }
});

const container = css({
  textAlign: "center",
  maxWidth: 760,
  margin: "0 auto",
  h3: {
    marginBottom: 48
  }
});

const Companies = ({ locale }) => {
  const localeLogos = locale ? logos[locale] : logos.au;
  return (
    <ContentBlock color="grey">
      <div className={container}>
        <H3>Join thousands of event organisers, big and small</H3>
        <Slider>
          <div className={wrapper}>
            <div>
              {localeLogos
                .filter(image => image.row == 1)
                .map(image => (
                  <Image alt={image.alt} src={image.img} />
                ))}
            </div>
            <div>
              {localeLogos
                .filter(image => image.row == 2)
                .map(image => (
                  <Image alt={image.alt} src={image.img} />
                ))}
            </div>
            <div>
              {localeLogos
                .filter(image => image.row == 3)
                .map(image => (
                  <Image alt={image.alt} src={image.img} />
                ))}
            </div>
          </div>
        </Slider>
      </div>
    </ContentBlock>
  );
};

export default CMSComponent(null, Companies, 500);
